/* eslint-disable no-unused-expressions */
import React, {useState} from 'react';
import {
  Box,
  FrameworkImage,
  GridContainerWithTitle,
  HorizontalDivider,
  Button,
  ArrowRightIcon,
  Typography,
  VerticalDivider,
  PurchaseTransitionModal,
  Pressable,
  ShareIcon,
  ActivityIndicator,
} from '@ttx/design-system';
import {useBreakpoint} from '@ttx/design-system/src/use-breakpoint';
import {usePlausible} from 'next-plausible';
import {useTtxQuery} from '../../../hooks/ttx-trpc';
import {
  LocalStroageUtil,
  LOCAL_STORAGE_KEY,
} from '../../../utils/local-storage-utils';

export interface SuccessModalProps {
  imageSrc?: string;
  artist?: string;
  trackName?: string;
  quantity?: number;
  onClose: () => void;
  trxHash?: string;
  onPress?: (dropId?: string | null) => void;
  isTraxxStemz?: boolean;
  isEmilG?: boolean;
  isJoshSavage?: boolean;
  tokenId?: number[];
  contractAddress?: string;
  isMobile?: boolean;
}

const SuccessModelView = ({
  artist,
  trackName,
  quantity,
  trxHash,
  isMobile,
}: SuccessModalProps) => {
  const trackNamesMsg = [
    'Sonic Starshifters  - Vaedar Pass Holders',
    'Resonant Savants - Vaedar Pass Holders',
    'Resonant Savants',
    'Sonic Starshifters',
  ];

  const studioPageMsg = [
    'EP1 Ryan edition',
    'EP1 Tommy edition',
    'EP1 Pedro edition',
    'EP1 Zach edition',
    'EP1 James edition',
    'EP1 Bundle',
  ];
  return (
    <>
      <Box>
        <Typography color="textDefault" textStyle="h2">
          Boom
        </Typography>
        <Box mt="s" />
        {trackName &&
          !studioPageMsg.includes(trackName) &&
          trackNamesMsg.includes(trackName) && (
            <Typography color="textDefault" textStyle="s">
              Your purchase was successful. You will be able to access the
              downloadables and other utility in the PERKS tab. Coming soon!
            </Typography>
          )}
        {trackName &&
          !studioPageMsg.includes(trackName) &&
          !trackNamesMsg.includes(trackName) && (
            <Typography color="textDefault" textStyle="s">
              You&apos;ve purchased a TT exclusive track.
            </Typography>
          )}
        {trackName &&
          !trackNamesMsg.includes(trackName) &&
          studioPageMsg.includes(trackName) && (
            <>
              <Typography color="textDefault" textStyle="s">
                You&apos;ve purchased a TT exclusive track.
              </Typography>
              <Typography color="textDefault" textStyle="s">
                Perk access will be given to the wallet used for purchase in a
                few days.
              </Typography>
            </>
          )}
      </Box>
      <Box paddingTop={isMobile ? 'four' : 'zero'}>
        {!!artist && (
          <Box flexDirection="row" mb="xs">
            <Typography color="textDefault" textStyle="s">
              {artist}, {trackName}
            </Typography>
            {/* <Typography color="textLow" textStyle="s">
              {' '}
              x{quantity}
            </Typography> */}
          </Box>
        )}
        {!!trxHash && (
          <Typography color="textLow" textStyle="s">
            #{trxHash}
          </Typography>
        )}
      </Box>
    </>
  );
};

const getContractAddress = (type: number) => {
  switch (type) {
    case 1:
      return process.env.TRAXX_CONTRACT_ADDRESS;
    case 2:
      return process.env.EMILG_CONTRACT_ADDRESS;
    case 3:
      return process.env.JOSH_CONTRACT;
    default:
      return process.env.TRAXX_CONTRACT_ADDRESS;
  }
};

export const SuccessModal: React.FC<SuccessModalProps> = ({
  imageSrc,
  artist,
  trackName,
  quantity,
  onClose,
  trxHash,
  onPress,
  isTraxxStemz,
  isEmilG,
  isJoshSavage,
  tokenId,
}: SuccessModalProps) => {
  const [purchaseModalState, setPurchaseModalState] = useState(false);
  const plausible = usePlausible();
  const [loadingShare, setLoadingShare] = useState(false);
  const {currentBreakpoint} = useBreakpoint();
  const isMobile = currentBreakpoint === '768px';

  let type = 3;
  if (isTraxxStemz) type = 1;
  if (isEmilG) type = 2;

  const {data, isLoading} = useTtxQuery(
    [
      'nft.getList',
      {
        tokenContract: [
          {
            tokenId: tokenId || [],

            contractAddress: getContractAddress(type),
          },
        ],
      },
    ],
    {
      refetchInterval: false,
    },
  );

  const blindMint = isTraxxStemz || isJoshSavage || isEmilG;

  const onMyNFT = () => {
    setPurchaseModalState(true);
  };
  if (purchaseModalState && onPress) {
    if (!isLoading && data?.length) {
      return (
        <PurchaseTransitionModal
          purchaseNfts={data || []}
          onClose={() => onPress(blindMint ? data[0]._id : null)}
        />
      );
    }
  }

  const onShare = () => {
    setLoadingShare(true);
    LocalStroageUtil.setItem(LOCAL_STORAGE_KEY.SHARE_FLOW, true);
    plausible('Share Selected (Total)');
    plausible('Share Selected (Purchase Flow)');
    onPress &&
      onPress(blindMint && data && data.length !== 0 ? data[0]._id : null);
  };

  return (
    <GridContainerWithTitle
      title="Purchase complete"
      onModalClose={onClose}
      maxWidth={600}
    >
      {isMobile ? (
        <Box>
          <Box height={366}>
            <FrameworkImage
              src={imageSrc || ''}
              alt={imageSrc || ''}
              layout="fill"
              objectFit="cover"
            />
          </Box>
          <HorizontalDivider />
          <Box m="lg" flex={1} justifyContent="space-between">
            <SuccessModelView
              artist={artist}
              trackName={trackName}
              quantity={quantity}
              onClose={onClose}
              trxHash={trxHash}
              isMobile={isMobile}
            />
          </Box>
        </Box>
      ) : (
        <Box flexDirection="row">
          <Box width={203} height={203}>
            <FrameworkImage
              src={imageSrc || ''}
              alt={imageSrc || ''}
              layout="fill"
              objectFit="cover"
            />
          </Box>
          <VerticalDivider />
          <Box m="lg" flex={1} justifyContent="space-between">
            <SuccessModelView
              artist={artist}
              trackName={trackName}
              quantity={quantity}
              onClose={onClose}
              trxHash={trxHash}
              isMobile={isMobile}
            />
          </Box>
        </Box>
      )}

      <HorizontalDivider />
      <Box flexDirection="row">
        <Box width="50%">
          <Button
            hasBorder={false}
            type="primary"
            size="S"
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            onPress={onPress && blindMint ? onMyNFT : onPress}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
          >
            View my NFT
          </Button>
        </Box>
        <Box width="50%">
          <Pressable onPress={onShare}>
            <Box
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              borderWidth="one"
              borderStyle="solid"
              borderColor="outlines"
              borderRadius="two"
              style={{
                margin: '8px 6px 8px 6px',
              }}
            >
              <Box
                flexDirection="row"
                alignItems="center"
                justifyContent="center"
                height="32px"
              >
                {loadingShare && (
                  <Box style={{position: 'absolute'}}>
                    <ActivityIndicator
                      color="outlines"
                      loaderColor="outlines"
                    />
                  </Box>
                )}
                {!loadingShare && (
                  <Typography
                    textStyle="s"
                    textAlign="center"
                    color="textDefault"
                  >
                    Share
                  </Typography>
                )}

                {!loadingShare && (
                  <Box ml="two">
                    <ShareIcon size={16} color="textDefault" />
                  </Box>
                )}
              </Box>
            </Box>
          </Pressable>
        </Box>
      </Box>
    </GridContainerWithTitle>
  );
};
